export enum MaintenanceCategory {
  CHECK = 'CHECK',
  CHECK_AND_REPAIR = 'CHECK_AND_REPAIR',
  REMINDER = 'REMINDER',
  STAND_ALONE = 'STAND_ALONE',
}
